<template>
    <div class="foot-menu clearfix" ref="foot">
            <el-row style="color: white;height: 100%;">
                <el-col :span="8" class="content" style="justify-content: flex-end;">
                    <div>
                        <div style="width: 20vw;display: flex;flex-direction: row;justify-content: center;">
                            <img src="../../assets/logo.png" style="width: 16vw;">
                        </div>
                        <p
                            style="font-size:30px;width: 20vw;display: flex;flex-direction: row;justify-content: center;margin-top: 5vh;font-family: QHKT;">
                            先进燃烧技术领跑者</p>
                    </div>
                    <el-divider direction="vertical"></el-divider>
                </el-col>

                <el-col :span="8" class="content">
                    <div style="height: 80%;width: 100%;">
                        <p style="margin-left: 20px;margin-bottom: 1vh;font-size: 30px;font-weight: bold;">联系我们</p>
                        <div class="title">
                            <p>商务邮箱: business@thupower.com.cn</p>
                        </div>

                        <div class="contact">
                            <div class="person">
                                <div class="code" style="margin-left: 2.7vw;">
                                    <img src="../../assets/商伟.png">
                                </div>
                                <p>动力合作：商先生</p>


                                <p>电话：131 3010 9813</p>
                            </div>
                            
                            <div class="person">
                                <div class="code" style="margin-left: 2.7vw;">
                                    <img src="../../assets/杨皓翔.png">
                                </div>
                                <p>供应商合作：杨先生</p>
                                <p>电话：185 1506 7789</p>
                            </div>
                            <div class="person">
                                <div class="code" style="margin-left: 2.7vw;">
                                    <img src="../../assets/王彦博.png">
                                </div>
                                <p>能源合作：王先生</p>
                                <p>电话：159 3264 3191</p>
                            </div>
                        </div>
                    </div>
                </el-col>

                <el-col :span="8" class="content" style="justify-content: flex-start;">
                    <el-divider direction="vertical"></el-divider>
                    <div style="margin-left: 3vw;height: 80%;">
                        <p style="font-size: 30px;font-weight: bold;margin-bottom: 1vh">关注我们</p>
                        <div style="display: flex;flex-direction: row;">
                            <p>微信公众号：清航空天</p>
                        </div>
                        <div class="code" style="margin-left: 4vw;">
                            <img src="../../assets/weChat.jpg">
                        </div>
                        <div style="display: flex;flex-direction: row;">
                            <p>投资合作：ir@thupower.com.cn</p>
                        </div>
                        <div style="display: flex;flex-direction: row;">
                            <p>媒体合作：meiti@thupower.com.cn</p>
                        </div>
                        <div style="display: flex;flex-direction: row;">
                            <p>前台电话：+86 010-50927668</p>
                        </div>
                        <div style="display: flex;flex-direction: row;">
                            <p>售后与意见：+86 010-50927668-805</p>
                        </div>
                    </div>
                </el-col>
            </el-row>
            <div class="footer" style="width: 100%;display: flex;flex-direction: row;justify-content:center;">
                <p style="color: white;font-size: 16px;">版权所有 © 清航空天（北京）科技有限公司 2021 京ICP备2021010296号-1 </p>
            </div>
        </div>
</template>
<script>
export default {
    data() {
        return {

        }
    },
    methods: {
        handleClick(path) {
            this.$router.push(path)
        }
    }
}
</script>
<style scoped lang="scss">
.foot-menu {
    margin: 0 auto;
    position: relative;
    background-color: #333333;
    padding: 30px 50px;
    padding-bottom: 100px;
    font-size: 22px;
    // background-image: url('../../assets/图4.jpg');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    height: 45vh;

    .code{
        height: 8vh;
        width: 8vh;
        display: flex;
        margin-top: 3vh;
    }
    .content {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        height: 100%;

        .contact{
            display: flex;
            flex-direction: row;
            margin-left: 20px;
            justify-content: space-between;
            width: 100%;
            .person{
                margin-right: 1vw;
                width: 30%;
                font-size: 16px;
                text-align: center;
            }
        }
    }

    .icon {
        display: flex;
        flex-direction: column;
        justify-content: center;
    }

    .title {
        display: flex;
        flex-direction: row;
        margin-left: 20px;
    }

    h3 {
        padding: 15px 0;
        font-weight: normal;
        font-size: 22px;
        text-align: left;
    }

    p {
        margin: 10px 0;

        // &:hover {
        //     color: rgb(172, 0, 0);
        //     cursor: pointer;
        // }
    }

    .right {
        display: flex;
        justify-content: center;
        padding: 0 50px;

        .right-content {
            width: 200px;
            height: 200px;

            img {
                width: 100%;
                height: 100%;
            }

            p {
                text-align: center;
            }
        }
    }

    .el-divider {
        background-color: rgba(187, 187, 187, 0.5);
        height: 50%;
    }

}
</style>
